import React from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import imagePaths from "../../../assets/imagePaths";
import { getPointsProgressDisplay } from "../../../utils/gamificationProgress";
import { BadgeIcon, GiftIcon } from "./Icons";
import { Link } from "react-router-dom";

const YourProgressPanel = ({
  progressData,
  onProfileClick,
  onPointsDashboardClick,
  onLevelJourneyClick,
  onLeaderboardClick,
  onBadgesClick,
  onRewardsClick,
}) => {
  const tier = progressData?.current_tier || {};
  const currentLevel = progressData?.current_level || 1;
  const tierKey = String(tier.key || "bronze").toLowerCase();
  const tierName = tier.name || `${tierKey.charAt(0).toUpperCase()}${tierKey.slice(1)} Tier`;
  const levelTitle = progressData?.level_title || "Consistent Level";
  const { progressPercent, fractionLabel } = getPointsProgressDisplay(
    progressData?.current_xp,
    progressData?.xp_required_for_completion
  );
  const req = Number(progressData?.xp_required_for_completion ?? 0);
  const cur = Number(progressData?.current_xp ?? 0);
  const streakSummaryText = progressData?.streak?.summary_text;
  const streakGraceText = progressData?.streak?.grace_text;
  const showStreakCard = Boolean(streakSummaryText || streakGraceText);
  const badges = Number(progressData?.badge_count || 0);
  const rewards = Number(progressData?.reward_count || 0);
  const remaining = req > 0 ? Math.max(0, req - cur) : 0;
  const fallbackTierIconByKey = {
    bronze: imagePaths.bronze,
    silver: imagePaths.silver,
    gold: imagePaths.gold,
    diamond: imagePaths.crown,
  };
  const tierIcon =
    tier.icon ||
    fallbackTierIconByKey[tierKey] ||
    imagePaths.medal ||
    imagePaths.crown;

    const rewardText = rewards === 0
    ? "No rewards available"
    : `${rewards} ${rewards === 1 ? "item" : "items"} ready to claim`;

  return (
    <div className="p-4 md:p-5 bg-[#F1ECFF]">
      <p className="text-[12px] text-[#7C7790] mb-3">
        <span className="cursor-pointer hover:underline text-[#7C7790] text-[12px]"  onClick={onProfileClick}>
          Profile
        </span>
        <span className="text-[#323232] text-[12px]"> &nbsp;&gt;&nbsp; </span> <span className="text-[#323232] text-[12px] font-medium">Your Progress</span>
      </p>

      <div
        className="rounded-3xl p-5 md:p-6 text-white relative overflow-hidden"
        style={{
          backgroundImage:
            "url('/bgImage.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <span className="text-xl font-semibold leading-none">Level {currentLevel}</span>
              <span className="px-4 py-1 font-semibold rounded-full bg-[#FFFFFF1A] border border-[#ccc] border-solid text-xl leading-none">
                {tierName}
              </span>
            </div>
            <p className="text-xl text-[#FFFFFF] font-normal leading-none">{levelTitle}</p>
          </div>
          <img alt="tier badge" src={tierIcon} className="w-20 h-20 object-contain" />
        </div>

        <div className="mt-7">
          <div className="flex items-center justify-between text-xl mb-2">
            <span>Points Progress</span>
            <span>{fractionLabel}</span>
          </div>
          <div className="h-3 bg-white/35 rounded-full overflow-hidden">
            <div
              className="h-full rounded-full"
              style={{
                width: `${progressPercent}%`,
                background: "linear-gradient(182.35deg, #FFFFFF -57.18%, #F3E6FF 91.87%)",
                transition: "width 0.4s ease",
              }}
            />
          </div>
          <p className="text-center text-xl text-[#FFFFFF] font-normal mt-3">
            {progressData?.points_away_text ||
              (req > 0
                ? `Just ${remaining} Points away from next level!`
                : "You reached the highest active level!")}
          </p>
        </div>
      </div>
      {showStreakCard && (
      <Link to={"/your-progress/streaks"} className="mt-4 rounded-2xl border-[0.5px] border-solid border-[#552F83] bg-white py-4 cursor-pointer px-5 flex items-center justify-between group hover:bg-[#F9F7FF] transition-colors duration-200 no-underline">
   
        <div className="flex items-center gap-3 justify-center">
          <div>
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="50" height="50" rx="11" fill="#FFD964" fill-opacity="0.25"/>
<path d="M25.832 34.8012C28.958 34.1752 33 31.9262 33 26.1112C33 20.8202 29.127 17.2962 26.342 15.6772C25.723 15.3172 25 15.7902 25 16.5052V18.3332C25 19.7752 24.394 22.4072 22.71 23.5022C21.85 24.0612 20.92 23.2242 20.816 22.2042L20.73 21.3662C20.63 20.3922 19.638 19.8012 18.86 20.3952C17.461 21.4602 16 23.3302 16 26.1102C16 33.2212 21.289 35.0002 23.933 35.0002C24.0877 35.0002 24.249 34.9952 24.417 34.9852C23.111 34.8742 21 34.0642 21 31.4442C21 29.3942 22.495 28.0092 23.631 27.3342C23.937 27.1542 24.294 27.3892 24.294 27.7442V28.3342C24.294 28.7842 24.469 29.4892 24.884 29.9712C25.354 30.5172 26.043 29.9452 26.098 29.2272C26.116 29.0012 26.344 28.8572 26.54 28.9712C27.181 29.3462 28 30.1462 28 31.4442C28 33.4922 26.871 34.4342 25.832 34.8012Z" fill="#B58F08"/>
</svg>
          </div>
       
<div className="flex flex-col gap-1 justify-center">

          <span className="text-[#563287] font-semibold text-lg -mt-2">{streakSummaryText}</span>
          <span className="text-[#323232] text-[12px]">{streakGraceText}</span>
</div>
      
        </div>
        <MdKeyboardArrowRight className="text-[#323232] w-7 h-7 transition-all duration-300 transform group-hover:translate-x-2" />
      </Link>
        )}

      <p className="mt-4 text-[16px] text-[#2f2f39] font-medium">Active Milestones</p>
      <div className="grid grid-cols-2 gap-3 mt-3">
        <div className="bg-white rounded-2xl py-5 px-12 flex items-center gap-4">
        <BadgeIcon />
          <div className=" ml-4">
            <p className="text-[#242424] text-2xl font-semibold leading-none">{String(badges).padStart(2, "0")}</p>
            <p className="text-[#7f7f8d] text-sm tracking-wide">BADGES</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl py-5 px-12 flex items-center gap-4">
          <GiftIcon />
            <div className=" ml-4">
            <p className="text-[#242424] text-2xl font-semibold leading-none">{String(rewards).padStart(2, "0")}</p>
            <p className="text-[#7f7f8d] text-sm tracking-wide">REWARDS</p>
          </div>
        </div>
      </div>

      <div className="mt-4 bg-white/70 rounded-2xl border border-[#E0D8F1] divide-y divide-[#ECE5F8]">
        <div
          className="group flex items-center justify-between px-4 py-4 cursor-pointer hover:bg-[#F9F7FF] transition-colors duration-200"
          onClick={() => onPointsDashboardClick?.()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onPointsDashboardClick?.();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <div className="flex items-center gap-3">
          <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="42" height="42" rx="11" fill="#F1ECFF"/>
<path d="M24 15V16.5H28.9395L22.5 22.9395L19.2802 19.7198C19.1396 19.5791 18.9489 19.5002 18.75 19.5002C18.5511 19.5002 18.3604 19.5791 18.2198 19.7198L10.5 27.4395L11.5605 28.5L18.75 21.3105L21.9697 24.5303C22.1104 24.6709 22.3011 24.7498 22.5 24.7498C22.6989 24.7498 22.8896 24.6709 23.0303 24.5303L30 17.5605V22.5H31.5V15H24Z" fill="#552F83"/>
</svg>

            <div className="flex flex-col gap-1 justify-center">
              <span className="text-base font-semibold text-[#323232]">Points Dashboard</span>
              <span className="text-[11px] text-[#7a7391]">See your points, active tier, and milestones.</span>
            </div>
          </div>
          <MdKeyboardArrowRight className="text-[#323232] w-7 h-7 transition-all duration-300 transform group-hover:translate-x-2" />
        </div>
        <div
          className="group flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-[#F9F7FF] transition-colors duration-200"
          onClick={() => onLevelJourneyClick?.()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onLevelJourneyClick?.();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <div className="flex items-center gap-3">
          <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="42" height="42" rx="11" fill="#DAB804" fill-opacity="0.15"/>
<g clip-path="url(#clip0_6202_33063)">
<path d="M21.0001 10.9848C21.0489 10.9843 21.0978 10.9839 21.1481 10.9834C22.3727 10.9872 23.3784 11.6973 24.3973 12.297C24.5927 12.4119 24.7886 12.5259 24.9845 12.64C25.0626 12.6856 25.1407 12.7312 25.2188 12.7768C25.2575 12.7993 25.2962 12.8219 25.336 12.8451C26.0782 13.2781 26.8204 13.711 27.5626 14.144C27.6013 14.1665 27.6399 14.1891 27.6798 14.2123C27.7579 14.2579 27.8359 14.3034 27.914 14.3489C28.1102 14.4634 28.3065 14.5779 28.5028 14.6922C28.698 14.8059 28.8932 14.9198 29.0882 15.0338C29.1649 15.0786 29.2416 15.1233 29.3184 15.168C30.8564 16.0636 30.8564 16.0636 31.0001 16.351C31.0287 16.5076 31.0331 16.6447 30.9528 16.7856C30.4166 17.43 29.4499 17.8201 28.737 18.2345C28.5407 18.3486 28.3446 18.4631 28.1485 18.5775C28.0704 18.6231 27.9923 18.6687 27.9141 18.7143C27.8755 18.7368 27.8368 18.7594 27.797 18.7826C27.0548 19.2156 26.3126 19.6485 25.5704 20.0815C25.5124 20.1153 25.5124 20.1153 25.4532 20.1498C25.3752 20.1953 25.2971 20.2409 25.2191 20.2864C25.0223 20.4012 24.8255 20.516 24.6288 20.6311C24.396 20.7672 24.1629 20.903 23.9298 21.0385C23.8932 21.0598 23.8567 21.081 23.8191 21.103C22.5836 21.8211 21.3972 22.3563 19.9454 21.976C19.1186 21.7363 18.3777 21.2286 17.642 20.7956C17.4465 20.6807 17.2506 20.5667 17.0548 20.4525C16.9766 20.407 16.8985 20.3614 16.8204 20.3158C16.7817 20.2933 16.7431 20.2707 16.7032 20.2475C15.5899 19.5981 15.5899 19.5981 14.4766 18.9486C14.4187 18.9148 14.4187 18.9148 14.3595 18.8803C14.2813 18.8347 14.203 18.789 14.1248 18.7434C13.931 18.6303 13.7372 18.5173 13.5433 18.4045C13.3489 18.2914 13.1546 18.178 12.9605 18.0644C12.8741 18.0138 12.7876 17.9634 12.701 17.9131C11.1504 17.0107 11.1504 17.0107 11.0001 16.7025C10.9615 16.5507 10.9657 16.4244 11.0326 16.2816C11.5693 15.5575 12.8015 15.096 13.5622 14.6591C13.8041 14.5201 14.0453 14.3799 14.2862 14.2392C14.3438 14.2056 14.3438 14.2056 14.4025 14.1713C14.4797 14.1261 14.5569 14.081 14.6342 14.0359C14.829 13.9221 15.0239 13.8084 15.2188 13.6947C15.297 13.6492 15.3751 13.6036 15.4532 13.558C15.6095 13.4669 15.7657 13.3757 15.922 13.2846C15.9606 13.262 15.9993 13.2395 16.0391 13.2162C16.1173 13.1706 16.1955 13.125 16.2737 13.0794C16.4681 12.966 16.6624 12.8526 16.8567 12.7391C17.3911 12.4269 17.926 12.1156 18.4629 11.8078C18.5359 11.7659 18.6089 11.7239 18.6818 11.6817C19.4314 11.2484 20.1165 10.9766 21.0001 10.9848Z" fill="#BD9C08"/>
<path d="M12.8159 19.5419C12.9166 19.5955 13.0166 19.6493 13.1153 19.7066C13.1546 19.7293 13.194 19.7521 13.2346 19.7755C13.277 19.8003 13.3194 19.825 13.3631 19.8504C13.4077 19.8763 13.4523 19.9021 13.4982 19.9288C13.9524 20.1923 14.4052 20.4583 14.858 20.7242C15.4491 21.0712 16.0416 21.4157 16.6356 21.7576C16.8845 21.901 17.1328 22.0454 17.3805 22.1907C18.9864 23.132 20.4638 23.749 22.3529 23.2904C23.4758 22.9928 24.5136 22.2784 25.5015 21.6892C25.6914 21.5765 25.8822 21.4655 26.073 21.3543C26.1315 21.3203 26.1315 21.3203 26.1912 21.2855C26.2702 21.2395 26.3492 21.1935 26.4282 21.1475C26.663 21.0107 26.8976 20.8738 27.1323 20.7369C27.3294 20.6218 27.5267 20.5069 27.724 20.3921C27.7636 20.3691 27.8031 20.3461 27.8438 20.3224C27.9224 20.2767 28.0009 20.2312 28.0796 20.1857C28.2706 20.0748 28.4595 19.9618 28.646 19.8434C28.6815 19.8212 28.717 19.7989 28.7535 19.776C28.8202 19.734 28.8865 19.6913 28.9523 19.6479C29.1691 19.5121 29.1691 19.5121 29.3198 19.5294C29.4798 19.6175 29.6354 19.7099 29.7889 19.8089C29.8378 19.8403 29.8378 19.8403 29.8876 19.8722C30.9425 20.5529 30.9425 20.5529 31.0254 20.8612C31.0413 21.0468 31.0096 21.1701 30.8924 21.3153C30.5536 21.6438 30.1535 21.8932 29.7498 22.1332C29.702 22.1618 29.6541 22.2906 29.6063 22.2193C29.5076 22.2786 29.4088 22.3379 29.31 22.397C29.1708 22.4804 29.032 22.5647 28.8935 22.6492C28.3757 22.965 27.8558 23.2767 27.3338 23.5855C27.034 23.763 26.7352 23.9415 26.4412 24.1286C26.1313 24.3242 25.8143 24.5082 25.4989 24.6947C25.173 24.8874 24.8485 25.0817 24.5276 25.2826C21.7523 27.0153 21.7523 27.0153 20.1404 26.6644C19.791 26.5728 19.4792 26.4444 19.1614 26.2738C19.1191 26.2514 19.0767 26.2289 19.0331 26.2058C18.6756 26.0148 18.3274 25.8104 17.9824 25.5978C17.796 25.4831 17.6088 25.3698 17.4217 25.2563C17.352 25.214 17.2823 25.1716 17.2126 25.1293C16.8742 24.9236 16.5349 24.7194 16.1951 24.516C15.7941 24.2758 15.3941 24.0342 14.9947 23.7913C14.6405 23.5758 14.2852 23.3619 13.9295 23.1488C13.409 22.8369 12.889 22.5239 12.3714 22.2073C12.2588 22.1386 12.1459 22.0706 12.033 22.0025C11.1558 21.4686 11.1558 21.4686 10.9998 21.1566C10.9729 20.9918 10.9639 20.8359 11.0416 20.6845C11.2515 20.4261 11.5442 20.2435 11.8201 20.0628C11.8563 20.0391 11.8925 20.0153 11.9298 19.9908C12.0497 19.9129 12.1703 19.8363 12.2913 19.7601C12.3304 19.7349 12.3694 19.7097 12.4096 19.6837C12.4468 19.6608 12.4839 19.6379 12.5222 19.6142C12.5719 19.583 12.5719 19.583 12.6226 19.5511C12.7186 19.516 12.7186 19.516 12.8159 19.5419Z" fill="#BD9C08"/>
<path d="M12.4844 23.9297C12.625 23.9475 12.7276 23.9877 12.8483 24.0603C12.8971 24.0893 12.8971 24.0893 12.9468 24.119C12.982 24.1403 13.0171 24.1616 13.0533 24.1836C13.1091 24.217 13.1091 24.217 13.1661 24.2512C13.2906 24.326 13.4149 24.4012 13.5391 24.4766C13.584 24.5037 13.6288 24.5309 13.6737 24.5581C13.8835 24.6851 14.0931 24.8124 14.3026 24.9399C14.5424 25.0858 14.7826 25.2309 15.0235 25.375C15.2812 25.5291 15.538 25.6846 15.7944 25.8408C16.3777 26.1959 16.9637 26.546 17.5516 26.8935C17.6888 26.9746 17.8258 27.0562 17.9625 27.1383C19.2667 27.92 20.6772 28.351 22.2103 27.9744C23.2704 27.6889 24.2054 27.0583 25.133 26.4922C25.4471 26.3005 25.7624 26.1109 26.0782 25.9219C26.4995 25.6696 26.9196 25.4152 27.339 25.1597C27.5891 25.0076 27.84 24.857 28.0919 24.7079C28.12 24.6912 28.1482 24.6745 28.1772 24.6574C28.3141 24.5763 28.451 24.4955 28.5881 24.4148C28.6383 24.3852 28.6884 24.3556 28.7385 24.326C28.7623 24.312 28.7862 24.298 28.8107 24.2835C28.9752 24.186 29.1315 24.0807 29.2838 23.965C29.3892 23.9158 29.4451 23.9343 29.5547 23.9688C29.6399 24.0094 29.6399 24.0094 29.7255 24.06C29.7573 24.0788 29.7892 24.0977 29.822 24.1171C29.8722 24.1476 29.8722 24.1476 29.9234 24.1787C29.9751 24.21 29.9751 24.21 30.0279 24.242C30.2434 24.3747 30.4511 24.514 30.6509 24.6694C30.673 24.6864 30.695 24.7035 30.7177 24.721C30.8712 24.8448 30.9772 24.961 31.0211 25.156C31.0276 25.339 31.0142 25.4641 30.8975 25.6094C30.4045 26.0966 29.7514 26.4223 29.1605 26.7757C29.0379 26.8491 28.9155 26.9226 28.793 26.9961C28.6461 27.0843 28.4992 27.1724 28.3522 27.2605C28.0231 27.4576 27.6949 27.6561 27.3672 27.8555C26.9658 28.0997 26.5634 28.3421 26.1603 28.5834C25.8306 28.7809 25.5017 28.9795 25.1735 29.1794C24.5536 29.5569 23.9309 29.9299 23.3047 30.2969C23.2671 30.3189 23.2295 30.341 23.1908 30.3637C22.224 30.9264 21.1733 31.2059 20.0503 30.9414C19.3978 30.7644 18.8247 30.3849 18.2518 30.039C18.0732 29.9312 17.8939 29.8246 17.7144 29.7186C17.2324 29.4338 16.7515 29.1481 16.2769 28.8512C15.9662 28.6576 15.6511 28.4715 15.336 28.2852C14.957 28.0611 14.58 27.8349 14.2068 27.6013C13.8945 27.4067 13.5776 27.2199 13.2608 27.0327C12.8267 26.7761 12.3949 26.5168 11.9717 26.2426C11.9025 26.1979 11.833 26.1538 11.7634 26.1099C11.1218 25.6966 11.1218 25.6966 11 25.4531C10.9907 25.3683 10.9907 25.3683 10.9878 25.2676C10.9864 25.2347 10.9849 25.2019 10.9834 25.1681C11.0296 24.8748 11.2816 24.7123 11.5048 24.5472C11.7837 24.35 12.0818 24.1809 12.3773 24.01C12.4438 23.9734 12.4438 23.9734 12.4844 23.9297Z" fill="#BD9C08"/>
</g>
<defs>
<clipPath id="clip0_6202_33063">
<rect width="20" height="20" fill="white" transform="translate(11 11)"/>
</clipPath>
</defs>
</svg>

            <div className="flex flex-col gap-1 justify-center">
              <span className="text-base font-semibold text-[#323232]">Your Level Journey</span>
              <span className="text-[11px] text-[#7a7391]">A reflection of your dedication over time.</span>
            </div>
          </div>
          <MdKeyboardArrowRight className="text-[#323232] w-7 h-7 transition-all duration-300 transform group-hover:translate-x-2" />
        </div>
        <div
          className="group flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-[#F9F7FF] transition-colors duration-200"
          onClick={() => onBadgesClick?.()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onBadgesClick?.();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <div className="flex items-center gap-3">
          <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="42" height="42" rx="11" fill="#EDE9FE"/>
<path d="M19.5242 33.0002L17.222 29.7973L13.3867 30.7201L16.6373 21.9707L22.7746 24.2509L19.5242 33.0002Z" fill="#552F83"/>
<path d="M28.2167 31.0023L24.4275 29.9059L21.9815 33.0006L19.1328 24.1125L25.368 22.1143L28.2167 31.0023Z" fill="#552F83"/>
<path d="M12 17.8014C12 12.9403 15.9405 9 20.8016 9C25.6631 9 29.6035 12.9403 29.6035 17.8014C29.6035 22.6627 25.6631 26.603 20.8016 26.603C15.9405 26.603 12 22.6627 12 17.8014Z" fill="#552F83"/>
<path d="M12.8438 17.8013C12.8438 13.4064 16.406 9.84375 20.8012 9.84375C25.1965 9.84375 28.7592 13.4064 28.7592 17.8013C28.7592 22.1966 25.1965 25.7591 20.8012 25.7591C16.406 25.7591 12.8438 22.1966 12.8438 17.8013Z" fill="white"/>
<path d="M13.2236 17.8022C13.2236 13.6171 16.616 10.2246 20.8014 10.2246C24.9871 10.2246 28.3796 13.6171 28.3796 17.8022C28.3796 21.9876 24.9871 25.38 20.8014 25.38C16.616 25.38 13.2236 21.9876 13.2236 17.8022Z" fill="white"/>
<path d="M13.4258 17.8015C13.4258 13.7279 16.7279 10.4258 20.8017 10.4258C24.8756 10.4258 28.1778 13.7279 28.1778 17.8015C28.1778 21.8753 24.8756 25.1775 20.8017 25.1775C16.7279 25.1775 13.4258 21.8753 13.4258 17.8015Z" fill="#552F83"/>
</svg>

            <div className="flex flex-col gap-1 justify-center">
              <span className="text-base font-semibold text-[#323232]">My Badges</span>
              <span className="text-[11px] text-[#7a7391]">Track your milestones.</span>
            </div>
          </div>
          <MdKeyboardArrowRight className="text-[#323232] w-7 h-7 transition-all duration-300 transform group-hover:translate-x-2" />
        </div>
        <div  onClick={() => onLeaderboardClick?.()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onLeaderboardClick?.();
            }
          }}
          role="button"
          tabIndex={0} className="group flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-[#F9F7FF] transition-colors duration-200">
          <div className="flex items-center gap-3">
          <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="42" height="42" rx="11" fill="#E0F2FE"/>
<path d="M15.5 30H12C11.45 30 11 29.55 11 29V19C11 18.45 11.45 18 12 18H15.5C16.05 18 16.5 18.45 16.5 19V29C16.5 29.55 16.05 30 15.5 30ZM22.75 12H19.25C18.7 12 18.25 12.45 18.25 13V29C18.25 29.55 18.7 30 19.25 30H22.75C23.3 30 23.75 29.55 23.75 29V13C23.75 12.45 23.3 12 22.75 12ZM30 20H26.5C25.95 20 25.5 20.45 25.5 21V29C25.5 29.55 25.95 30 26.5 30H30C30.55 30 31 29.55 31 29V21C31 20.45 30.55 20 30 20Z" fill="#0284C7"/>
</svg>

<div className="flex flex-col gap-1 justify-center">
              <span className="text-base font-semibold text-[#323232]">Go to Leaderboard</span>
              <span className="text-[11px] text-[#7a7391]">See how you compare.</span>
            </div>
          </div>
          <MdKeyboardArrowRight className="text-[#323232] w-7 h-7 transition-all duration-300 transform group-hover:translate-x-2" />
        </div>
        <div className="group flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-[#F9F7FF] transition-colors duration-200"
        onClick={() => onRewardsClick?.()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onRewardsClick?.();
            }
          }}
        >
          <div className="flex items-center gap-3">
          <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="42" height="42" rx="11" fill="#FFE4E6"/>
<path d="M18.06 10.9297C16.17 10.9197 14.33 12.7397 15.17 14.9997H12C11.4696 14.9997 10.9609 15.2104 10.5858 15.5855C10.2107 15.9606 10 16.4693 10 16.9997V18.9997C10 19.2649 10.1054 19.5193 10.2929 19.7068C10.4804 19.8944 10.7348 19.9997 11 19.9997H20V16.9997H22V19.9997H31C31.2652 19.9997 31.5196 19.8944 31.7071 19.7068C31.8946 19.5193 32 19.2649 32 18.9997V16.9997C32 16.4693 31.7893 15.9606 31.4142 15.5855C31.0391 15.2104 30.5304 14.9997 30 14.9997H26.83C28 11.7297 23.6 9.41973 21.57 12.2397L21 12.9997L20.43 12.2197C19.8 11.3297 18.93 10.9397 18.06 10.9297ZM18 12.9997C18.89 12.9997 19.34 14.0797 18.71 14.7097C18.08 15.3397 17 14.8897 17 13.9997C17 13.7345 17.1054 13.4802 17.2929 13.2926C17.4804 13.1051 17.7348 12.9997 18 12.9997ZM24 12.9997C24.89 12.9997 25.34 14.0797 24.71 14.7097C24.08 15.3397 23 14.8897 23 13.9997C23 13.7345 23.1054 13.4802 23.2929 13.2926C23.4804 13.1051 23.7348 12.9997 24 12.9997ZM11 20.9997V28.9997C11 29.5302 11.2107 30.0389 11.5858 30.4139C11.9609 30.789 12.4696 30.9997 13 30.9997H29C29.5304 30.9997 30.0391 30.789 30.4142 30.4139C30.7893 30.0389 31 29.5302 31 28.9997V20.9997H22V28.9997H20V20.9997H11Z" fill="#F43F5E"/>
</svg>

<div className="flex flex-col gap-1 justify-center"
>
              <span className="text-base font-semibold text-[#323232]">My Rewards</span>
             

<span className="text-[11px] text-[#7a7391]">
  {rewardText}
</span>
            </div>
          </div>
          <MdKeyboardArrowRight className="text-[#323232] w-7 h-7 transition-all duration-300 transform group-hover:translate-x-2" />
        </div>
      </div>
    </div>
  );
};

export default YourProgressPanel;
